import { Fragment } from "react";
import "./index.scss";
import { ButtonV1 } from "lib";
import { useMemo } from "react";
import { useSelector,useDispatch } from "react-redux";
import { ACTIONS_CLASS_MAPPER } from "constants/formButton";
import { triggerButtonCallback } from "helper/triggerButtonCallback";
import { Container } from "react-bootstrap";
// import { IndirectEval } from 'helper/indirectEval'
import PropTypes from "prop-types";

const FormButton = (props) => {
  FormButton.propTypes = {
    handleOfflinePayment: PropTypes.func,
    handleOfflinePartialPayment: PropTypes.func,
    handlePaymentInitiation: PropTypes.func,
    handleUpdatePartialPaymentViaRequestChanges: PropTypes.func,
    handleUpdateFullPaymentViaRequestChanges: PropTypes.func,
    handleSendPaymentLink: PropTypes.func,
  };

  const {
    handleNext,
    handleCancel,
    handleFieldAddMore,
    handleSubmission,
    handleFinalSubmisssion,
    handleSkip,
    handleEdit,
    handleBack,
    formButtons = [],
    selectWorkflow,
    handleAddMore,
    handleGenerateForm,
    isRecursive = false,
    className,
    //Being used in the eval. Please don't remove
    selectedData = {},
    minLength,
    maxLength,
    handleSubmitUploadedeDocs,
    handleSubmitRequestedChanges,
    handleSubmitApplication,
    handleSkipApplication,
    handleLinkWithCrn,
    handleDelinkWithCrn,
    handleDeclarationAcceptance,
    handleUpdateCustom,
    handleTerminate,
    handlePayment,
    handelAddRecursiveData,
    handleUaePassAuth,
    customClass,
    handlePaymentInitiation,
    handleOfflinePayment,
    handleOfflinePartialPayment,
    handleUpdatePartialPaymentViaRequestChanges,
    handleUpdateFullPaymentViaRequestChanges,
    handleCREdit,
    handleFormCompleted,
    handleSendPaymentLink,
    handleSkipOtp,
    handleValidateData,
    handleVerify,
    handleBackFilter,
    handleSaveFilter,
    handleBulkUpload
  } = props;

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const isDuplicateFormInput = useSelector((state) => state.formData.isDuplicateFormInput);

  //Being used in the IndirectEval(expression) for recursive components. Do not remove
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const updateCustomBtn = useMemo(() => {
    return query.get("updateCustomBtn");
  }, [search, query]);

  const transaction_id = useMemo(() => {
    return query.get("transaction_id");
  }, [search, query]);
  
  const recursive = useSelector((state) => state.recursive);
  const guardianRecursive = useSelector((state) => state.guardianRecursive);
  const showRecursiveForm = useSelector(
    (state) => state.recursive?.showRecursiveForm
  );
  const isEditRecursiveForm = useSelector(
    (state) => state.recursive?.isEditRecursiveForm
  );
  const consentLoading = useSelector((state) => state?.consentReducer?.loading);
  const formData = useSelector((state) => state?.formData);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const otpReducer = useSelector((state) => state?.otpReducer);
  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const userInfo = useSelector((state) => state?.userInfo);
  const stepperReducer = useSelector((state) => state?.stepperReducer);
  const vkycCallback = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.vcip_callback
  );
  const emandateCallback = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.userSubworkFlowInfo?.emandate_callback
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const isPaymentInProgess = useSelector(
    (state) => state.formData?.isPaymentInProgess
  );
  const dashboardDetailReducer = useSelector(
    (state) => state?.dashboardDetailReducer
  );
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const dispatch = useDispatch();
  const maxAmountExceeded = useSelector(
    (state) => state?.paymentReducer?.maxAmountExceeded
  );
  const isEnteredAmountZero = useSelector(
    (state) => state?.paymentReducer?.isEnteredAmountZero
  );
  const isRemainingAmountZero = useSelector(
    (state) => state?.paymentReducer?.isRemainingAmountZero
  );
  const isMaximumAmount = useSelector(
    (state) => state?.paymentReducer?.isMaximumAmount
  );

  const paymentDetails = useSelector(
    (state) => state?.paymentReducer?.payment_details
  );

  const paymentTransactionsFetching = useSelector(
    (state) => state?.paymentReducer?.paymentTransactionsFetching
  );
  const isCreatingPayment = useSelector(
    (state) => state?.paymentReducer?.isCreatingPayment
  );
  const activeTab = useSelector((state)=>state?.dashboardDetailReducer?.activeNavTab)

  const handleClick = (
    action,
    callbacks_triggers,
    extra_params,
    status_to_update,
    id,
    trigger,
    auto_fill_trigger,
    autofill,
    paymentPayload,
    triggerPaymentCreation,
    amount,
    requestChangeSettings,
    content_trigger,
    module_settings
  ) => {
    switch (action) {
      case "add":
        handleNext(action, { isRecursive });
        break;
      case "addGuardian":
        handleNext(action, { isRecursive });
        break;
      case "next":
        selectWorkflow && selectWorkflow();
        handleNext(action, {
          isRecursive,
          status_to_update,
          callbacks_triggers,
          id,
          trigger,
          auto_fill_trigger,
          autofill,
          triggerPaymentCreation,
          amount,
          content_trigger,
          module_settings,
        });
        break;
      case "cancel":
        handleCancel();
        break;
      case "skip":
        handleSkip();
        break;
      case "edit":
        handleEdit();
        break;
      case "back":
        handleBack();
        break;
      case "addNew":
        handleAddMore();
        break;
      case "addNewGuardian":
        handleAddMore("guardian");
        break;
      case "addField":
        handleFieldAddMore();
        break;
      case "generateForm":
        handleGenerateForm();
        break;
      case "update":
        handleNext(action, { isRecursive });
        break;
      case "reject":
        handleNext(action);
        break;
      case "approve":
        handleNext(action, { extra_params });
        break;
      case "OnHold":
          handleNext(action, { extra_params });
          break;
      case "reinitiate":
        handleNext(action);
        break;
      case "reinitiate-vkyc":
        handleNext(action);
        break;
      case "uploadSupportingDocs":
        handleSubmitUploadedeDocs();
        break;
      case "submit":
        handleSubmission(action, isRecursive);
        break;
      case "updateRequestedChanges":
        handleSubmitRequestedChanges(action);
        break;
      case "physicalFormSubmission":
        handleNext(action, {
          isRecursive,
          callbacks_triggers,
          content_trigger,
        });
        break;
      case "formCompleted":
        handleFormCompleted(action);
        break;
      case "handleSubmitApplication":
        handleSubmitApplication(action, {
          isRecursive,
          status_to_update,
          callbacks_triggers,
          content_trigger,
        });
        break;
      case "handleSkipApplication":
        handleSkipApplication(status_to_update, callbacks_triggers,content_trigger);
        break;
      case "link_with_crn":
        handleLinkWithCrn();
        break;
      case "delink_with_crn":
        handleDelinkWithCrn();
        break;
      case "consent":
        handleDeclarationAcceptance(content_trigger, callbacks_triggers);
        break;
      case "updateCustom":
        handleUpdateCustom(
          action,
          isRecursive,
          status_to_update,
          callbacks_triggers,
          id,
          trigger,
          auto_fill_trigger,
          autofill
        );
        break;
      case "terminate":
        handleTerminate({ termination: true, revoke_termination: false });
        break;
      case "undo_terminate":
        handleTerminate({ termination: false, revoke_termination: true });
        break;
      case "payment":
        handlePayment(action, status_to_update);
        break;
      case "add_recursive":
        handelAddRecursiveData();
        break;
      case "uae_pass_auth":
        handleUaePassAuth();
        break;
      case "paymentSubmit":
        handlePaymentInitiation(action, {
          isRecursive,
          paymentPayload,
          triggerPaymentCreation,
          amount,
        });
        break;
      case "offlinePayment":
        handleOfflinePayment(action, status_to_update);
        break;
      case "offlinePartialPayment":
        handleOfflinePartialPayment(action, status_to_update);
        break;
      case "offlinePartialPaymentUpdate":
        handleUpdatePartialPaymentViaRequestChanges(action);
        break;
      case "offlineFullPaymentUpdate":
        handleUpdateFullPaymentViaRequestChanges(action);
        break;
      case "cr_edit":
        handleCREdit();
        break;
      case "sendPaymentLink":
        handleSendPaymentLink(action, "", "", requestChangeSettings);
        break;
      case "skip_otp":
        handleSkipOtp();
        break;
      case "handleBackFilter":
        handleBackFilter();
        break;
      case "handleSaveFilter":
        handleSaveFilter();
        break;
        //used in Header structue form button
        case "handleValidateData":
          handleValidateData();
          break;
          case "verifyBtn":
            handleVerify();
        break;
        case "handleBulkUpload":
          handleBulkUpload()
          break;
      default:
        handleSkip();
        break;
      // default: handleNext(action)
      //     break;
    }
    // if (!callbacks_triggers) return;
    // callbacks_triggers.forEach((callback) => {
    //   if (!IndirectEval(callback.required)) return;
    //   callback = IndirectEval(callback);
    //   let evaluatedCallbackParams = {};
    //   Object.entries(callback.params).map((item) => {
    //     let key = item[0];
    //     let val = item[1];
    //     evaluatedCallbackParams[key] = IndirectEval(val);
    //   });
    //   let evaluatedCallback = {
    //     ...evaluatedCallbackParams,
    //   };
    //   triggerButtonCallback(evaluatedCallback,dispatch);
    // });
  };

  const mapClassToAction = (action) => {
    for (const key in ACTIONS_CLASS_MAPPER)
      if (ACTIONS_CLASS_MAPPER[key].includes(action)) return key;
  };

  const checkRenderAllowed = (expression) => {
    let allowed = false;
    if (!expression) {
      allowed = true;
    } else {
      allowed = IndirectEval(expression);
    }
    return allowed;
  };

  const validateDupicateError = () => {
    let data = Object.entries(isDuplicateFormInput).some(([key, value]) => {
      return value === true;
    });
    return data;
  };
  

  const getClassName = () => {
    const buttons =
      formButtons &&
      Array.isArray(formButtons) &&
      formButtons.filter((btn) => checkRenderAllowed(btn.show));
    if (buttons.length <= 1) {
      //updating the className based on if btn count is more than 1
      return "justify-content-end";
    } else {
      return "justify-content-between";
    }
  };

  return (
    //  <div
    //    className={`${
    //      window.innerWidth < 640 ? "form-button-mobile" : "form-button "
    //    } ${className ? className : getClassName()}`}
    //  >
    <div
      className={`form-button form-button-mobile button-position py-lg-0 w-100 mt-3 ${customClass} ${getClassName()}`}
    >
      {formButtons &&
        Array.isArray(formButtons) &&
        formButtons.map((_button, index) => {
          const {
            label,
            action,
            show,
            disabled,
            variant = "primary",
            className = "",
            callbacks_triggers,
            confirmation_content,
            extra_params,
            status_to_update,
            id,
            trigger,
            auto_fill_trigger,
            autofill,
            triggerPaymentCreation,
            amount,
            icon_type,
            uae_pass_action,
            module_settings: paymentPayload,
            requestChangeSettings,
            content_trigger,
            module_settings
          } = _button;
          return (
            <Fragment key={index}>
              {checkRenderAllowed(show) && (
                <ButtonV1
                  label={label}
                  onClick={() =>
                    handleClick(
                      action,
                      callbacks_triggers,
                      extra_params,
                      status_to_update,
                      id,
                      trigger,
                      auto_fill_trigger,
                      autofill,
                      paymentPayload,
                      triggerPaymentCreation,
                      amount,
                      requestChangeSettings,
                      content_trigger,
                      module_settings
                    )
                  }
                  className={`${
                    window.innerWidth < 640 ? "block" : ""
                  } ${className} ${mapClassToAction(action)}`}
                  variant={variant}
                  disabled={disabled && IndirectEval(disabled)}
                  confirmation_content={confirmation_content}
                  icon_type={icon_type}
                  uae_pass_action={uae_pass_action}
                />
              )}
            </Fragment>
          );
        })}
    </div>

    //  </div>
  );
};

export default FormButton;
